import React from "react";
import {
  ContentItemGrid,
  ContentItemGridProps,
} from "~/components/ContentItemGrid";
import {
  ContentItemWithImage,
  ContentItemWithImageProps,
} from "~/components/ContentItemWithImage";
import { ContentItemWithImageSkeleton } from "~/components/ContentItemWithImageSkeleton";
import { LoadMoreButton } from "~/components/LoadMoreButton";
import { ReadMorePostsRenderProps } from "~/components/ReadMorePosts/ReadMorePosts";

export type ReadMorePostItemsProps = ReadMorePostsRenderProps & {
  className?: string;
  imagePosition: ContentItemWithImageProps["imagePosition"];
  title: string | undefined | null;
  variant: ContentItemGridProps["variant"];

  displayDate?: boolean;
  displayKicker?: boolean;
  displayFooter?: boolean;
};

export const ReadMorePostsItems: React.FC<ReadMorePostItemsProps> = ({
  className,
  contentItems,
  isLoading,
  imagePosition,
  onLoadMore,
  showSkeleton,
  showLoadMore,
  title,
  variant,
}) => (
  <>
    <ContentItemGrid
      className={className}
      itemBorder={false}
      title={title}
      variant={variant}
    >
      {contentItems.map(({ itemProps, key }) => (
        <ContentItemWithImage
          key={key}
          {...itemProps}
          imagePosition={imagePosition}
        />
      ))}
      {showSkeleton
        ? Array(12)
            .fill(null)
            .map((i, idx) => (
              <ContentItemWithImageSkeleton
                key={idx}
                imagePosition={imagePosition}
              />
            ))
        : null}
    </ContentItemGrid>
    {showLoadMore ? (
      <LoadMoreButton onClick={onLoadMore} updating={isLoading} />
    ) : null}
  </>
);
